import { render } from "./ArrangeComponent.vue?vue&type=template&id=efacdcb6&scoped=true"
import script from "./ArrangeComponent.vue?vue&type=script&lang=js"
export * from "./ArrangeComponent.vue?vue&type=script&lang=js"

import "./ArrangeComponent.vue?vue&type=style&index=0&id=efacdcb6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efacdcb6"]])

export default __exports__